var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoBaggageChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4C17.0437 4 17.087 4.0014 17.13 4.00416L13.1341 8H8.00002V9H12.1341L5.00002 16.1341V6C5.00002 4.89543 5.89546 4 7.00002 4H8.00002V3C8.00002 1.89543 8.89546 1 10 1H14C15.1046 1 16 1.89543 16 3V4H17ZM19 7.81737L23.3174 3.49999L21.8924 2.07499L2.09241 21.875L3.51741 23.3L5.49743 21.32C5.86397 21.7369 6.40127 22 7.00002 22C7.00002 22.5523 7.44774 23 8.00002 23C8.55231 23 9.00002 22.5523 9.00002 22H15C15 22.5523 15.4477 23 16 23C16.5523 23 17 22.5523 17 22C18.1046 22 19 21.1046 19 20V7.81737ZM14 3V4H10V3H14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBaggageChecked);
export default __webpack_public_path__ + "static/media/no_baggage_checked.a05307df9812ab1863d4cdfd1e1407cc.svg";
export { ForwardRef as ReactComponent };